import { Box, Grid } from "@mui/material";
import { JSX } from "react";
import { FeedBoxPanels } from "views/knowledge/feed/components/FeedBoxPanels";
import { OutsideRightPanel } from "views/knowledge/publication/pages/components/OutsideRightPanel";

////////////////////////////////////////////////////////////////////////////////

interface PageContentBoxProps {
    id?: string;
    content?: JSX.Element;
    rightPanel?: React.ReactElement[];
    openRightPanel: boolean;
    onCloseRighPanel: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const TrainingViewContainer = ({ id, content, rightPanel, openRightPanel, onCloseRighPanel }: PageContentBoxProps) => {
    return (
        <Box
            id={id}
            sx={(theme) => ({
                maxWidth: theme.breakpoints.values["xl"], margin: "0 auto"
            })}
        >
            <Grid container spacing={2}>
                <Grid size="grow">
                    {content}
                </Grid>
                <Grid sx={{ width: "300px", display: { xs: "none", sm: "none", md: "block" } }}>
                    <FeedBoxPanels>{rightPanel}</FeedBoxPanels>
                </Grid>
            </Grid>

            {
                openRightPanel &&
                <OutsideRightPanel
                    onClose={onCloseRighPanel}
                    content={<>{rightPanel}</>}
                />
            }

        </Box>
    );
};
